export const SITE_NAME = "FitMyResume";
export const SITE_URL = "https://fitmyresume.com";
export const SITE_TAGLINE = "Job Tailored Resumes";
export const SUPPORT_EMAIL = "admin@fitmyresume.com";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
